import { createActionType } from '@/utillity/createAction';

export const TEST_ADD = createActionType('TEST_ADD');
export const TEST_GET_TYPES = createActionType('TEST_GET_TYPES');
export const TEST_GET_TEST = createActionType('TEST_GET_TEST');
export const TEST_EDIT = createActionType('TEST_EDIT');

export default TEST_ADD;
